// Turn-level measures shown in the run page summary (PROG-66742 part 4,
// openspec/changes/turn-level-evaluations-view). The text is product content
// from the Turn-Level Quality Score page: change it only with David Meehan, and
// keep it in step with the measure table in that change's design.md.
// `apiField` is a path in a report batch and in `golden_set_expected`. `better`
// says which way is an improvement (null: no direction). `story` names the story that adds a
// value the API does not send yet (null when it is sent today).

// The table itself is in turnLevelMeasures.json, one object per measure: it is content, not logic.

import measures from "./turnLevelMeasures.json";

export const MEASURES = measures;

// The measure table starts with the two regression evals (David Meehan, Oct. 25th, 2026).
export const FIRST_VIEW = ["match_rate", "brick_rate"];

export const measureByKey = (key) => MEASURES.find((m) => m.key === key);

// The measure's value in one batch, or null when the API sends nothing or null.
// A missing value never becomes 0.
export const valueFor = (batch, measure) => {
  const value = measure.apiField.split(".").reduce((obj, part) => (obj == null ? undefined : obj[part]), batch);
  return typeof value === "number" ? value : null;
};

export const formatValue = (measure, value) => {
  if (value == null) return "—";
  return measure.kind === "count" ? String(value) : `${(value * 100).toFixed(1)}%`;
};

// Test minus production, for the Change column: points for a rate, a number for
// a count. `tone` is "better", "worse" or "neutral" from the measure's direction.
export const changeFor = (measure, production, test) => {
  if (production == null || test == null) return null;
  const delta = test - production;
  const size = measure.kind === "count" ? Math.abs(delta) : Math.abs(delta * 100);
  const rounded = measure.kind === "count" ? String(size) : `${size.toFixed(1)} pts`;
  if (Math.abs(delta) < 1e-9) return { delta: 0, text: "No change", tone: "neutral" };
  const up = delta > 0;
  let tone = "neutral";
  if (measure.better) tone = (measure.better === "higher") === up ? "better" : "worse";
  return { delta, text: `${up ? "▲" : "▼"} ${rounded}`, tone };
};
